import { useQuery } from "@tanstack/react-query"
import { columns } from "./partial/Columns"
import { DataTable } from "./partial/DataTable"
import SkeletonTable from "@/components/SkeletonTable"
import { getListTeganganListrikAset } from "@/services/getData"

export default function MasterTeganganListrikAsetPage() {
  const { data, isPending } = useQuery({
    queryKey: ["listTeganganListrikAset"],
    queryFn: getListTeganganListrikAset,
  })

  if (isPending) return <SkeletonTable />

  return (
    <div>
      <DataTable data={data || []} columns={columns} />
    </div>
  )
}
